import React, { useState } from 'react';
import { FaStar, FaGoogle } from "react-icons/fa";

export default function TestimonialCard({ item, title = "Client Feedback", showStars = true }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => setIsExpanded(prev => !prev);

  const stars = Array.from({ length: item.rating || 5 }, (_, i) => (
    <FaStar key={i} style={{ color: "#ffca05", fontSize: "14px" }} />
  ));

  const isLongText = item.review.length > 160;
  const previewText = item.review.slice(0, 160) + "...";

  return (
    <div style={styles.card}>
      <div style={styles.googleIcon}>
        <FaGoogle size={18} color="#4285F4" title="Review from Google" />
      </div>

      {showStars && <div style={styles.stars}>{stars}</div>}

      <h3 style={styles.title}>{title}</h3>

      <p style={styles.review}>
        {isExpanded || !isLongText ? item.review : previewText}
      </p>

      {isLongText && (
        <button onClick={toggleExpand} style={styles.readMoreBtn}>
          {isExpanded ? "Read Less" : "Read More"}
        </button>
      )}

      <div style={styles.author}>
        <img
          src={item?.imgUrl}
          alt={item?.name || "Client"}
          onError={(e) => (e.target.src = "https://via.placeholder.com/40")}
          style={styles.avatar}
        />
        <div>
          <div style={styles.name}>{item?.name}</div>
          <div style={styles.time}>{item?.time}</div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  card: {
    position: "relative",
    background: "#fff",
    borderRadius: "16px",
    padding: "16px",
    boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
    maxWidth: "280px",
    minHeight: "250px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0 auto",
    boxSizing: "border-box",
  },
  googleIcon: {
    position: "absolute",
    top: "12px",
    right: "12px",
  },
  stars: {
    display: "flex",
    gap: "4px",
    marginBottom: "6px"
  },
  title: {
    fontSize: "14px",
    fontWeight: "600",
    marginBottom: "6px",
    color: "#111"
  },
  review: {
    fontSize: "13px",
    color: "#444",
    marginBottom: "6px",
    lineHeight: "1.4",
    flexGrow: 1,
  },
  readMoreBtn: {
    background: "none",
    border: "none",
    color: "#1d3a6c",
    fontSize: "13px",
    cursor: "pointer",
    marginBottom: "10px",
    padding: 0,
    alignSelf: "flex-start",
  },
  author: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "auto",
  },
  avatar: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    objectFit: "cover"
  },
  name: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#1d3a6c"
  },
  time: {
    fontSize: "11px",
    color: "#999"
  }
};
